import Vue from "vue";
import { Permissoes } from "./permissoes";

export class Usuario {
    static create() {
        return {
            nome: null,
            email: null,
            permissoes: Permissoes.create(),
            contrato_id: null
        };
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static auth(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("auth", data)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static updatePasswordByToken(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("usuario/update/password", data)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("usuario/" + data._id, data);
            } else {
                promisse = Vue.http.post("usuario/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @returns {Promise}
     */
    static level() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("me/level")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param token
     * @return {Promise}
     */
    static getByToken(token) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("usuario/by-token/" + token)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("usuarios")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static byContrato(contratoID) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("usuarios/by-contrato/" + contratoID)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static byPK(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("usuario/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param token
     * @return {Promise}
     */
    static authToken(token) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("auth/" + token)
                .then(res => resolve(res.data), err => reject(err));
        });
    }
}
